(function(){
      if (window.__luxQv) return;
      window.__luxQv = true;

      function closeQv(){
        var m = document.querySelector('.lux-qv');
        if (m) m.remove();
      }

      document.addEventListener('click', function(e){
        if (!e.target || !e.target.closest) return;
        if (e.target.closest('.lux-qv__scrim') || e.target.closest('.lux-qv__x')){
          e.preventDefault(); e.stopPropagation(); closeQv(); return;
        }
        var plus = e.target.closest('.lux-xs__plus');
        if (!plus) return;
        e.preventDefault(); e.stopPropagation();
        openQv(plus.closest('.lux-xs__card'));
      }, true);

      document.addEventListener('keydown', function(e){
        if (e.key === 'Escape' && document.querySelector('.lux-qv')){
          e.stopPropagation(); closeQv();
        }
      }, true);

      function openQv(card){
        if (!card) return;
        var raw = card.querySelector('.lux-qv-data');
        if (!raw) return;
        var d;
        try { d = JSON.parse(raw.textContent); } catch (err) { return; }
        var host = document.querySelector('.cart-drawer__inner');
        if (!host) return;
        closeQv();

        var names = d.opts.map(function(o){ return o.n; });
        var sel = {};
        d.opts.forEach(function(o){ if (o.vals.length === 1) sel[o.n] = o.vals[0].v; });

        var m = document.createElement('div');
        m.className = 'lux-qv';
        m.innerHTML =
          '<div class="lux-qv__scrim"></div>' +
          '<div class="lux-qv__panel" role="dialog" aria-modal="true">' +
            '<button type="button" class="lux-qv__x" aria-label="Close">✕</button>' +
            '<div class="lux-qv__gal"></div>' +
            '<div class="lux-qv__body">' +
              '<h3 class="lux-qv__t"></h3>' +
              '<div class="lux-qv__opts"></div>' +
              '<div class="lux-qv__pr"></div>' +
              '<button type="button" class="lux-qv__cta"></button>' +
              '<a class="lux-qv__full" href="' + d.u + '">View full details</a>' +
            '</div>' +
          '</div>';
        host.appendChild(m);
        m.querySelector('.lux-qv__t').textContent = d.t;

        // o painel engole os cliques para o "clique fora" do tema nao fechar o drawer
        m.querySelector('.lux-qv__panel').addEventListener('click', function(ev){
          ev.stopPropagation();
        });

        // fechar o drawer descarta o modal, senao ele reaparece na proxima abertura
        var dlg = host.closest('dialog');
        if (dlg) dlg.addEventListener('close', closeQv);

        function variantFor(){
          for (var i = 0; i < d.vars.length; i++){
            var v = d.vars[i], ok = true;
            for (var j = 0; j < names.length; j++){
              if (sel[names[j]] !== v.o[j]) { ok = false; break; }
            }
            if (ok) return v;
          }
          return null;
        }

        function canPick(optName, val){
          return d.vars.some(function(v){
            if (!v.a) return false;
            for (var j = 0; j < names.length; j++){
              var n = names[j];
              if (n === optName){ if (v.o[j] !== val) return false; }
              else if (sel[n] && sel[n] !== v.o[j]) return false;
            }
            return true;
          });
        }

        var ordered = d.opts.slice().sort(function(a, b){
          return (/size/i.test(b.n) ? 1 : 0) - (/size/i.test(a.n) ? 1 : 0);
        });

        function gallery(){
          var g = m.querySelector('.lux-qv__gal');
          var v = variantFor();
          var list = d.imgs.slice();
          if (v && v.im) list = [v.im].concat(list.filter(function(x){ return x !== v.im; }));
          g.innerHTML = list.map(function(src){
            return '<img src="' + src + '" alt="" loading="lazy">';
          }).join('');
          g.scrollLeft = 0;
        }

        // os botoes sao criados UMA vez; o clique so atualiza estado.
        // recriar o DOM aqui destacava o alvo do clique no meio do evento,
        // e o tema lia isso como clique fora e fechava o drawer.
        var ctrls = [];
        (function buildOpts(){
          var box = m.querySelector('.lux-qv__opts');
          ordered.forEach(function(o){
            var isColour = /colou?r|cor/i.test(o.n);
            var grp = document.createElement('div');
            grp.className = 'lux-qv__grp';
            grp.innerHTML = '<div class="lux-qv__lbl"><span>' + o.n + ': <b></b></span></div>' +
                            '<div class="lux-qv__vals"></div>';
            var lbl = grp.querySelector('b');
            var vals = grp.querySelector('.lux-qv__vals');
            o.vals.forEach(function(val){
              var b = document.createElement('button');
              b.type = 'button';
              b.className = isColour ? 'lux-qv__v lux-qv__sw' : 'lux-qv__v';
              if (isColour){
                b.title = val.v;
                b.style.background = '#DDD';
                if (val.sw) b.style.background = val.sw;
                else b.style.background = val.v.toLowerCase().replace(/\s+/g, '');
              } else {
                b.textContent = val.v;
              }
              b.addEventListener('click', function(ev){
                ev.preventDefault();
                ev.stopPropagation();
                if (sel[o.n] === val.v) delete sel[o.n];
                else sel[o.n] = val.v;
                refresh();
                gallery();
              });
              vals.appendChild(b);
              ctrls.push({ opt: o, val: val, btn: b, lbl: lbl });
            });
            box.appendChild(grp);
          });
        })();

        function refresh(){
          ctrls.forEach(function(c){
            c.btn.setAttribute('aria-pressed', sel[c.opt.n] === c.val.v ? 'true' : 'false');
            c.btn.disabled = !canPick(c.opt.n, c.val.v);
            c.lbl.textContent = sel[c.opt.n] ? sel[c.opt.n] : 'Choose ' + c.opt.n.toLowerCase();
          });

          var v = variantFor();
          var ref = v || d.vars.filter(function(x){ return x.a; })[0] || d.vars[0];
          var html = '';
          if (ref){
            html = '<span class="now">' + ref.p + '</span>';
            if (ref.c){
              html += '<s class="was">' + ref.c + '</s>';
              var n1 = Number(String(ref.p).replace(/[^0-9.]/g, ''));
              var n2 = Number(String(ref.c).replace(/[^0-9.]/g, ''));
              if (n2 > n1) html += '<span class="off">' + Math.round((1 - n1 / n2) * 100) + '% OFF</span>';
            }
          }
          m.querySelector('.lux-qv__pr').innerHTML = html;

          var cta = m.querySelector('.lux-qv__cta');
          var missing = ordered.filter(function(o){ return !sel[o.n]; });
          if (missing.length){
            cta.textContent = 'Select a ' + missing[0].n.toLowerCase();
            cta.disabled = true;
          } else if (!v || !v.a){
            cta.textContent = 'Sold out';
            cta.disabled = true;
          } else {
            cta.textContent = 'Add to cart';
            cta.disabled = false;
          }
        }

        m.querySelector('.lux-qv__cta').addEventListener('click', function(ev){
          ev.preventDefault();
          ev.stopPropagation();
          var v = variantFor();
          if (!v || !v.a) return;
          var form = card.querySelector('form[data-type="add-to-cart-form"]');
          if (!form) return;
          var input = form.querySelector('input[name="id"]');
          input.removeAttribute('disabled');
          input.value = v.id;
          var sub = form.querySelector('button[type="submit"]');
          closeQv();
          if (form.requestSubmit) form.requestSubmit(sub || undefined);
          else form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
        });

        gallery();
        refresh();
      }
    })();
